﻿import { useState } from 'react';
import { Button, Space, Typography, message } from 'antd';
import { surveyAnalyticsService } from '../../../services/surveyAnalytics.service';
import type { ExportSummary, QueryDefinition } from '../../../types/survey-analytics.types';

export function ExportPanel({ surveyId, versionId, definition }: { surveyId: string; versionId: string; definition: QueryDefinition }) {
  const [summary, setSummary] = useState<ExportSummary | null>(null);
  const [loading, setLoading] = useState(false);
  const create = async () => { setLoading(true); try { const created = await surveyAnalyticsService.createExport(surveyId, versionId, definition); const final = created.status === 'COMPLETED' ? created : await surveyAnalyticsService.getExport(surveyId, versionId, created.exportId); setSummary(final); } finally { setLoading(false); } };
  const download = async () => { if (!summary) return; const location = await surveyAnalyticsService.createExportDownloadUrl(surveyId, versionId, summary.exportId); message.success(`Download pronto: ${location.fileName}`); };
  return <Space wrap>
    <Button loading={loading} onClick={create}>Exportar CSV</Button>
    {summary && <Typography.Text>Status: {summary.status === 'COMPLETED' ? 'concluído' : summary.status.toLowerCase()}</Typography.Text>}
    {summary?.status === 'COMPLETED' && <Button onClick={download}>Baixar</Button>}
  </Space>;
}
export default ExportPanel;
